// @flow
import * as React from 'react';
import styled from 'styled-components';
import { below } from '../../../assets/css/media';
import colors from '../../../assets/css/colors';
import {
	TableFlexRow,
	OverflowHidden,
	BorderedIcon,
	TableFlexCell,
	LeagueTypeLabel,
	LeagueAvatar,
	LeagueName
} from "../../../components";

import Settings from '../../../components/Icons/Settings';
import ArrowRight from '../../../components/Icons/ArrowRight';

const LeagueNameWrapper = styled(OverflowHidden)`
	flex-basis: 50%;
	
	.league-avatar {
		width: 47px;
		margin: 0 .5em 0 1em;
	}
	
	${below.desktop`
		flex-basis: 70%;
		display: flex;
		align-items: center;
		justify-content: center;
		
		.league-name {
			text-align: left;
		}
		
		p {
			margin-left: 10px;
		}
	`}
	
	${below.small_phone`
		.league-name p {
			width: 100px;
		}
	`}
`;

const TableFlexCellStyled = styled(TableFlexCell)`
	flex-basis: 10%;
`;

type Props = {
	league: Object,
	handleLeagueJoinPopup: Function,
	handleLeagueSettingsPopup: Function,
	join: Function
};

export const JoinLeagueRow = ({
	league, handleLeagueJoinPopup, handleLeagueSettingsPopup, join
}: Props) => (
	<TableFlexRow key={league.id} height="60px">
		<LeagueNameWrapper role="cell" className="hidden-mobile">
			<LeagueTypeLabel rotate="-90"
				text={league.privacy ? 'PUBLIC' : 'PRIVATE'}
			/>
			<LeagueAvatar league={league} size="40px" className='league-avatar' />
			<LeagueName
				name={league.name}
				width="90%"
				lastname={league.lastname}
				firstname={league.firstname}
			/>
		</LeagueNameWrapper>
		<LeagueNameWrapper role="cell" className="hidden-desktop">
			<LeagueTypeLabel rotate="-90"
				className="league-label"
				text={league.privacy ? 'PUBLIC' : 'PRIVATE'}
			/>
			<LeagueName
				className="league-name"
				name={league.name}
				width="90%"
				lastname={league.lastname}
				firstname={league.firstname}
			/>
		</LeagueNameWrapper>
		<TableFlexCellStyled role="cell" className="hidden-mobile">
			{league.num_teams}/{league.size}
		</TableFlexCellStyled>
		<TableFlexCellStyled role="cell" className="hidden-mobile">
			{league.start_round}
		</TableFlexCellStyled>
		<TableFlexCellStyled role="cell">
			<BorderedIcon hover={colors.lightGreen}>
				<Settings cursor="pointer"
					join={join}
					size="1.875"
					color={colors.nrlDarkGreen}
					onClick={handleLeagueSettingsPopup.bind(this, { id: league.id })}
				/>
			</BorderedIcon>
		</TableFlexCellStyled>
		<TableFlexCellStyled role="cell">
			<BorderedIcon hover={colors.lightGreen}>
				<ArrowRight cursor="pointer"
					size="1.875"
					color={colors.nrlDarkGreen}
					onClick={handleLeagueJoinPopup.bind(this, { id: league.id })}
				/>
			</BorderedIcon>
		</TableFlexCellStyled>
	</TableFlexRow>
);

export default JoinLeagueRow;


// WEBPACK FOOTER //
// ./src/pages/leagues/leaguesJoin/JoinLeagueRow.js